/**
 * 车辆信息
 * @type {{vinCode: null, orderId: string, plateNo: string, newCarFlag: boolean, ownerInfo: {ownerIdentityNo: null}}}
 */

const quoteVehicleInfo = {
    orderId: '', // 订单号
    vehicleInfo: {
        // newCarFlag: false,   // 是否新车
        // plateNo: '', // 车牌号
        usageAttribute: 'FYY', //使用性质
        usageAttributeDetailCode:'',
        vehicleFrameNo: "",  // 车架号
        engineNo: null, // 发动机号
        firstRegisterDate: "", // 初登日期
        modelCode: null, // 车辆类型
        modelName: '',
        vehicleType: '',
        seartNumber: '', // 座位数
        wholeWeight: null, //整备质量
        vehicleTonnages: null, //核定载质量
        transferFlag: 2, // 是否过户
        transferDate: null, // 过户日期
        carPrice:0,
        carSeries:'',
        vehicleClassCode:'',
        vehicleTypeCode:'',
        vehicleTypeDetailCode:'',
      offerLocalUseProof:false
    },
    personInfo:{
        ownerName:'',
        ownerIdentityType:1,
        ownerIdentityNo:'',
        ownerSex:1,
        ownerBirthday:'',
        ownerTelNo:'',
        phName:'',
        phIdentityType:1,
        phIdentityNo:'',
        phSex:1,
        phBirthday:'',
        phTelNo:'',
        phAddress:'',
        phContactName:'', // 投保人经办人姓名
        phContactIdentityType:1, // 投保人经办人证件类型
        phContactIdentityNo:'', // 投保人经办人证件号
        phContactTelNo:'', // 投保人经办人电话号
        phContactEmail:'',//投保人联系人电子邮箱
        phGroupType:1, // 投保人组织机构类型
        // insuredType:'',
        insuredName:'',
        insuredIdentityType:1,
        insuredIdentityNo:'',
        insuredSex:1,
        insuredBirthday:'',
        insuredAddress:'',
        insuredTelNo:'',
        insuredGroupType:1, // 被保人组织机构类型
        insuredContactName:'', // 被保人联系人姓名
        insuredContactTelNo:'', // 被保人联系人电话
        insuredContactEmail:'',//被保人联系电子邮箱
        insuredContactIdentityType:1,//被保人联系人证件类型
        insuredContactIdentityNo:''//被保人联系人证件号
    },
    quoteVehicleExtraVO:{
        orderId:'',
        huarunBranchName:'', // 华润渠道使用，华润利润中心名称
        huarunPersonName:'', // 华润渠道使用，华润 推荐人姓名
        zfbName:'',//支付宝名称
        zfbId:'',//支付宝账号
        name:'',//收件人名称
        address:'',//地址
        tel:'',//收件人手机号
        payPersonType:'',//支付人类型 1：投保人 2：被保人
        wljjCompanyName:'',//韦莱渠道使用，所属公司代码
        wljjPhChangzhudi:'',//韦莱渠道使用，投保人常驻地（大陆32个省自治区直辖市）
        wljjInsuredChangzhudi:'',//韦莱渠道使用，被保人常驻地（大陆32个省自治区直辖市）
        payee:'',//收款人
        bankNo:'',//银卡号
        bankSubBranch:'',//支行信息
        payeeIdNo:'',//收款人身份证
        payeeTel:'',//收款人电话

        jobNumber:'',//员工工号
        isNewPersonnel:'',//是否新员工 1是 2否
    },
    // 商业险报价明细
    chooseCovers: {
        commercial: {
            startTime: null,
            checked: false,
            fixedCode:false, // 是否有固定险种
            c01: { // 车辆损失险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: null,//保额
                ndiFlag: false,// 投保不计免赔标识
                coverName:'车辆损失险'
            },
            c02: { // 第三者责任险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 500000,//保额
                ndiFlag: false,// 投保不计免赔标识
                minPremium: null, // 最小保额
                coverName:'第三者责任险'
            },
            /*
            c03: { // 全车盗抢险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                ndiFlag: false,// 投保不计免赔标识
                coverName:'全车盗抢险'
            },
            */
            c04: { // 司机责任险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 200000,//保额
                ndiFlag: false,// 投保不计免赔标识
                minPremium: null, // 最小保额
                coverName:'司机责任险'
            },
            c05: { // 乘客责任险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 300000,//保额
                seats: null,// 投保座位数,乘客险
                ndiFlag: false,// 投保不计免赔标识
                minPremium: null, // 最小保额
                coverName:'乘客责任险'
            },
            /*
            c06: { // 玻璃单独破碎险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 1,// 国产，进口
                coverName:'玻璃单独破碎险'
            },
            */
            c07: { // 车身划痕损失险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 20000,//保额
                ndiFlag: false,// 投保不计免赔标识
                coverName:'车身划痕损失险'
            },
            /*
            c08: { // 自燃损失险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                ndiFlag: false,// 投保不计免赔标识
                coverName:'自燃损失险'
            },
            c09: { // 发动机涉水损失险-
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                ndiFlag: false,// 投保不计免赔标识
                coverName:'发动机涉水损失险'
            },
            */
            c10: { // 修理期间费用补偿险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: null,// 每天多少钱
                fixDays: null, // 天数
                coverName:'修理期间费用补偿险'
            },
            c11: {
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: null,//保额
                ndiFlag: false,// 投保不计免赔标识
                coverName:'新增设备险'
            },
            c12: { // 指定修理厂险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 1,//保额
                coverName:'指定修理厂险'
            },
            /*
            c13: { // 机动车损失保险无法找到第三方特约险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                coverName:'机动车损失无法找到第三方特约险'
            },*/
            c24: { // 附加车轮单独损失险
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 5000,//保额
                coverName:'车轮单独损失险'
            },
            c26: { // 附加发动机进水损坏除外特约
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                coverName:'发动机进水损坏除外'
            },
            c25: { // 绝对免赔率特约险(车损)
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 5,//保额
                coverName:'绝对免赔率(车损)'
            },
            c27: { // 附加精神损害抚慰金责任险-三者
                fixedCode:false, // 固定险种，不须修改
                premium: 2000,//保额
                checked: false,//是否选择
                coverName:'精神损害抚慰金(三者)'
            },
            c28: { // 附加法定节假日限额翻倍险-车损
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                coverName:'三者法定节假日翻倍险'
            },
            c29: { // 绝对免赔率特约险-三者
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 5,//保额
                coverName:'绝对免赔率(三者)'
            },
            c30: { // 附加医保外医疗费用责任险-三者
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 0,//保额
                coverName:'医保外用药责任险(三者)'
            },
            c31: { // 附加精神损害抚慰金责任险-司机
                fixedCode:false, // 固定险种，不须修改
                premium: 2000,//保额
                checked: false,//是否选择
                coverName:'精神损害抚慰金(司机)'
            },
            c32: { // 绝对免赔率特约险-司机
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 5,//保额
                coverName:'绝对免赔率(司机)'
            },
            c33: { // 附加医保外医疗费用责任险-司机
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 0,//保额
                coverName:'医保外用药责任险(司机)'
            },
            c34: { // 附加精神损害抚慰金责任险-乘客
                fixedCode:false, // 固定险种，不须修改
                premium: 2000,//保额
                checked: false,//是否选择
                coverName:'精神损害抚慰金(乘客)'
            },
            c35: { // 绝对免赔率特约险-乘客
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 5,//保额
                coverName:'绝对免赔率(乘客)'
            },
            c36: { // 附加医保外医疗费用责任险-乘客
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 0,//保额
                coverName:'医保外用药责任险(乘客)'
            },
            c20: { // 附加机动车增值服务特约条款（道路救援服务特约条款）
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 22,//保额
                coverName:'道路救援服务'
            },
            c21: { // 附加机动车增值服务特约条款（道路救援服务特约条款）
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 1,//保额
                coverName:'车辆安全检测服务'
            },
            c22: { // 附加机动车代驾服务
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 1,//保额
                coverName:'代为驾驶服务'
            },
            c23: { // 附加机动车代为送检服务
                fixedCode:false, // 固定险种，不须修改
                checked: false,//是否选择
                premium: 1,//保额
                coverName:'年检代办服务'
            }
        },
        // 交强险报价明细
        traffic: {
            checked: false,
            startTime: null, //交强险起保日期
            csx: false, // 投保车船税
        },
        coverInfoMsg:{
            c01: { // 车辆损失险
                name:"车损险",
                rate:95,
                msg:"赔付您自己爱车的损失,并附赠7*24小时免费道路救援哦",
                fit:"所有车主"
            },
            c02: { // 第三者责任险
                name:"三者险",
                rate:99,
                msg:"赔付需要您承担的他人人身伤亡及财产损失",
                fit:"所有车主"
            },
            c03: { // 全车盗抢险
                name:"全车盗抢险",
                rate:52,
                msg:"负责赔付全车被盗窃、被抢劫、被抢夺造成车辆的损失",
                fit:"所有车主,特别是停放区域治安不好,经常外岀或新购高档车等盗抢高风险车辆"
            },
            c04: { // 司机责任险
                name:"司机险",
                rate:72,
                msg:"负责赔付车內驾驶员本人的人身伤亡费用",
                fit:"所有车主,特别是新手和经常开车或经常将车借给别人的情况"
            },
            c05: { // 乘客责任险
                name:"乘客险",
                rate:63,
                msg:"负责赔付车內本车乘客(非驾驶员)的人身伤亡费用",
                fit:"所有车主,特别是经常带父母和小孩外出车主"
            },
            c06: { // 玻璃单独破碎险
                name:"玻璃险",
                rate:35,
                msg:"赔付挡风玻璃和车窗玻璃单独破碎的损失(不包括车灯、车镜玻璃）",
                fit:"经常走高速路或车辆停放区域治安不好等情况的车辆"
            },
            c07: { // 车身划痕损失险
                name:"划痕险",
                rate:8,
                msg:"负责赔付他人恶意行为造成的保险车辆车身人为划痕",
                fit:"仅建议新车购买"
            },
            c08: { // 自燃损失险
                name:"自燃损失险",
                rate:30,
                msg:"负责赔付因线路老化等自身原因起火造成车辆本身的损失",
                fit:"通常3年以上的车主会考虑购买"
            },
            c09: { // 发动机涉水损失险-
                name:"发动机涉水险",
                rate:40,
                msg:"赔付车辆因遭水淹或因涉水行驶造成发动机损坏的修复费用",
                fit:"多雨及內涝地区车主"
            },
            c10: { // 修理期间费用补偿险
                name:"修理期间费用补偿险",
                rate:30,
                msg:"车辆修理期间产生的代步车费用或弥补停驶损失",
                fit:"所有车主"
            },
            c12: { // 指定修理厂险
                name:"指定修理厂险",
                rate:30,
                msg:"赔付车辆在被保险人指定的修理厂维修的費用",
                fit:"通常倾向于去4S店修车的客户会考虑购买"
            },
            c13: { // 机动车损失保险无法找到第三方特约险
                name:"无法找到第三方险",
                rate:99,
                msg:"赔付车损无法找到第三方的免赔金额",
                fit:"所有车主"
            },
            c20: { // 附加机动车增值服务特约条款（道路救援服务特约条款）
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加机动车道路救援服务'
            },
            c21: { // 附加机动车增值服务特约条款（道路救援服务特约条款）
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加机动车安全检测服务'
            },
            c22: { // 附加机动车代驾服务
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加机动车代驾服务'
            },
            c23: { // 附加机动车代为送检服务
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加机动车代为送检服务'
            },
            c24: { // 附加车轮单独损失险
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加车轮单独损失险'
            },
            c25: { // 绝对免赔率特约险(车损)
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'绝对免赔率特约险'
            },
            c26: { // 附加发动机进水损坏除外特约
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加发动机进水损坏除外特约'
            },
            c27: { // 附加精神损害抚慰金责任险-车损
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加精神损害抚慰金责任险'
            },
            c28: { // 附加法定节假日限额翻倍险-车损
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加法定节假日限额翻倍险'
            },
            c29: { // 绝对免赔率特约险-车损
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'绝对免赔率特约险'
            },
            c30: { // 附加医保外医疗费用责任险-车损
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加医保外医疗费用责任险'
            },
            c31: { // 附加精神损害抚慰金责任险-司机
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加精神损害抚慰金责任险'
            },
            c32: { // 绝对免赔率特约险-司机
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'绝对免赔率特约险'
            },
            c33: { // 附加医保外医疗费用责任险-司机
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加医保外医疗费用责任险'
            },
            c34: { // 附加精神损害抚慰金责任险-乘客
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加精神损害抚慰金责任险'
            },
            c35: { // 绝对免赔率特约险-乘客
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'绝对免赔率特约险'
            },
            c36: { // 附加医保外医疗费用责任险-乘客
                fit:"无", // 固定险种，不须修改
                msg: "无",//是否选择
                rate: 0,//保额
                name:'附加医保外医疗费用责任险'
            }
        },

    },
    fileData: {
        plateNo: "", // 车牌号
        phName: "",// 投保人名称
        insuredName: "",// 被保人名称
        ownerName: "",// 车主名称
        fileTypeLs: {}, // 上传的文件类型
    },
    theme:{
        blue:{
            theme:"blue",
            mainColor:"#406cff",  // 主色
            changeMaiColor:"rgba(96,107,255, 0.42)", // 主色渐变
            stressColor:"#e7121c", // 强调色
            stressColor1:"#ff9d33", // 强调色 1
            supportColor:"#6689ff", // 辅助色
            changeBgColor:"linear-gradient(0deg, #406dff 0%, #606bff 100%)",//渐变背景色

        },
        orange:{
            theme:"orange",
            mainColor:"#e59c3f", // 主色
            changeMaiColor:"#e59c3f", // 主色渐变
            stressColor:"#e7121c", // 强调色
            stressColor1:"#406cff", // 强调色 1
            supportColor:"#ff9d33", // 辅助色
            changeBgColor:"linear-gradient(0deg, #e59c3f 0%, #e59c3f 100%)",//渐变背景色
        }
    }

}
export default quoteVehicleInfo;



// WEBPACK FOOTER //
// ./src/public/QuoteVehicleInfo.js